import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.css';
import en from 'date-fns/locale/en-GB';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import daysFromNow from 'helpers/daysFromNow';

const CalendarContainer = ({ date, setDate, setShow, quickDateOptions }) => {
  const [selected, setSelected] = useState(date);
  const [month, setMonth] = useState(date);
  const initialDate = useMemo(() => date);

  useEffect(() => {
    setSelected(date);
  }, [date]);

  useEffect(() => {
    setMonth(selected);
  }, [selected]);

  const handleDateChange = (e) => {
    if (e) {
      const date = new Date(e);
      date.setHours(new Date().getHours(), new Date().getMinutes(), new Date().getSeconds());
      setSelected(date);
    }
  };

  const handleContinue = () => {
    setDate(selected);
    setShow(false);
  };

  const handleCancel = () => {
    setDate(initialDate);
    setShow(false);
  };

  const formatWeekdayName = (day) => {
    return (
      <>
        <span>{day.toLocaleString(undefined, { weekday: 'short' })}</span>
      </>
    );
  };

  return (
    <>
      <div className={styles.dateButtonContainer}>
        {quickDateOptions.map((option) => {
          return (
            <div key={option.name}>
              <button
                className={`coop-btn ${styles.dateButton} ${
                  selected.toDateString() === daysFromNow(option.daysFromNow).toDateString()
                    ? ''
                    : styles.dateButtonInactive
                }`}
                onClick={() => {
                  setSelected(daysFromNow(option.daysFromNow));
                }}>
                {option.displayText}
              </button>
            </div>
          );
        })}
      </div>
      <div className={styles.calendarContainer}>
        <DayPicker
          className={styles.customPicker}
          month={month}
          onMonthChange={setMonth}
          mode="single"
          selected={selected}
          onSelect={handleDateChange}
          weekStartsOn={1}
          fromDate={daysFromNow(1)}
          toMonth={daysFromNow(365)}
          locale={en}
          formatters={{ formatWeekdayName }}
        />
        <button className={`coop-btn ${styles.continueButton}`} onClick={handleContinue} disabled={!date}>
          Select date
        </button>
        <button className={`coop-btn ${styles.cancelButton}`} onClick={handleCancel} disabled={!date}>
          Cancel
        </button>
      </div>
    </>
  );
};

export default CalendarContainer;
